module.exports = __webpack_public_path__ + "Icono_CdEstado-Bco_126px.png";